import React from "react";
import PaperWorkNeeded from "../../PicesForPages/PaperWorkNeeded.png";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function PaperWork() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent PaperworkNeededtopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={PaperWorkNeeded}
          alt="NewsPaperImage"
          className="background-video PaperworkNeededtopImage"
        />
        <div className="purchasetopBox PaperworkNeededtopBox">
          {/* The existing Purchase span */}
          <span>Paperwork Needed</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              To secure a loan, you must provide the lender with comprehensive
              records of your financial background. The lender will obtain a
              credit report from a credit bureau and confirm the details in your
              loan application. Be ready to submit:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Social Security numbers for yourself and any co-borrowers</li>
              <li>
                Bank statements for your checking and savings accounts from the
                past two months
              </li>
              <li>
                Proof of additional assets such as bonds, stocks, or funds in
                retirement accounts (e.g., 401k or 403b plans)
              </li>
              <li>Recent pay stubs</li>
              <li>
                W-2 forms or income tax returns for the last two years to verify
                your income and employment
              </li>
              <li>
                Contact information of a person who can confirm your employment
              </li>
              <li>Your residential history for the past two years</li>
              <li>A sales agreement for the purchase of a new property</li>
              <li>
                Homeowner's association details with contact information if the
                property is a condo or within a homeowner's association
              </li>
            </ul>
            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default PaperWork;
